import { render, staticRenderFns } from "./EventFeatures.vue?vue&type=template&id=16d7c192&scoped=true&"
import script from "./EventFeatures.vue?vue&type=script&lang=js&"
export * from "./EventFeatures.vue?vue&type=script&lang=js&"
import style0 from "./EventFeatures.vue?vue&type=style&index=0&id=16d7c192&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d7c192",
  null
  
)

export default component.exports